<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty Notice</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
                        label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
                </v-col>
                <v-col cols="12" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined dense type="date" v-model="fromdate" label="From Date(inclusive)"
                        hint="From Date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-text-field outlined dense type="date" v-model="todate" label="To Date(exclusive)"
                        hint="To Date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2">
                    <v-btn class="mt-7 button" @click="fetchNotices()" :loading="send_btn_load">Fetch Notices</v-btn>
                </v-col>
            </v-row>
            <v-card class="" flat v-if="communication_list != ''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Notices</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-row class="row_class mt-2" dense v-for="header, index in communication_list" :key="index"
                        @click="viewMore(header)" :class="header.is_read_by_faculty ? 'weaklyoff2' : 'weaklyoff'">
                        <!-- <v-col cols="12" sm="2" md="2"> {{ header.from }} </v-col> -->
                        <v-col cols="12" sm="10" md="10"> {{ header.title }}</v-col>
                        <v-col cols="12" sm="2" md="2"> {{ header.date }}</v-col>
                    </v-row>
                </v-col>
            </v-card>
        </v-card>

        <v-dialog v-model="dialog_view" v-if="view_notice != null" max-width="1200px">
            <v-card>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-toolbar flat dense class="toolbar">
                            <v-toolbar-title>
                                From:{{ view_notice.from }}
                                <!-- {{ view_notice.title }} - {{ view_notice.date }}  -->
                            </v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer style="margin-left: 600px;">Date : {{ view_notice.date }}</v-spacer>
                        </v-toolbar>
                        <v-col cols="12" sm="12" md="12">
                            <v-card flat>
                                <strong style="color: darkcyan;">Title</strong>
                                <br />
                                <v-row class="pl-9 mt-2 mb-3" v-html="view_notice.title"></v-row>
                            </v-card>
                            <v-card flat>
                                <strong style="color: darkcyan;">Description</strong>
                                <!-- <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                <v-btn x-small class="pl-2" icon v-if="view_notice.url" v-bind="attrs" v-on="on"> <v-icon  style="color:darkcyan">mdi-eye</v-icon></v-btn>
                                                </template>
<span> Visit Link!!! </span>
</v-tooltip> -->
                                <br />
                                <v-row class="pl-9 mt-2 mb-3" v-html="view_notice.description"></v-row>
                            </v-card>
                            <v-card flat>
                                <strong style="color: darkcyan;">Link</strong> <br>
                                <template v-if="view_notice.url && view_notice.url !== 'null'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <!-- Anchor tag wrapping the button for opening the link -->
                                            <a :href="view_notice.url" target="_blank" rel="noopener noreferrer"
                                                v-bind="attrs" v-on="on">
                                                <v-btn small class="pl-9 mt-2 mb-3" icon>
                                                    <v-icon style="color:black">mdi-logout</v-icon>
                                                </v-btn>
                                            </a>
                                        </template>
                                        <span>Visit Link!!!</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>


                                    <v-btn small class="pl-9 mt-2 mb-3" icon>
                                        <v-icon style="color:red">mdi-close-circle</v-icon>
                                    </v-btn>
                                </template>


                            </v-card>

                            <v-card style="color: darkcyan;" flat v-if="view_notice.attachment_list != ''">
                                <strong> Downloadable Attachment</strong>
                                <span v-for="(item, i) in view_notice.attachment_list" :key="i">
                                    <a class="p-2" :href="basepath + item.link" target="blank">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-if="view_notice.attachment_list != null != null"
                                                    v-bind="attrs" v-on="on"> <v-icon
                                                        color="black">mdi-file</v-icon></v-btn>
                                            </template>
                                            <span> View Attachment File!!! </span>
                                        </v-tooltip>
                                    </a>
                                </span>
                            </v-card>
                        </v-col>
                    </v-card>
                    <!-- <v-card-text>
                      {{  view_notice }}  
                    </v-card-text> -->
                    <v-card-actions class="justify-center">
                        <v-btn class="dialog-btn" @click="dialog_view = false">Close</v-btn>
                    </v-card-actions>
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        ay_list: [],
        academicyear: null,
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),
        from_date: null,
        to_date: null,
        search: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        title: null,
        inst: [],
        inst_list: [],
        basepath: null,
        communication_list: [],
        dialog_view: false,
        view_notice: null,
    }),
    watch: {},
    methods: {
        viewMore(notice) {
            this.view_notice = notice;
            const formData = {
                id: notice.id,
                type: "Notice",
            };
            axios
                .post("/Communication/noticeOrAlbumViewedByFaculty", formData)
                .then((res) => {
                    if (res.data.msg == "200") {
                        if (res.data.status == "SUCCESS") {
                            this.dialog_view = true;
                            // this.fetchNotices();
                        } else {
                            alert(res.data.status_reason);
                        }
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.fetchNotices();
                });
        },
        fetchNotices() {
            this.init_loader = true;
            const formData = {
                fromdate: this.fromdate,
                todate: this.todate,
                ay: this.academicyear.id,
            };
            axios
                .post("/Communication/getFacultyCommunication", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.d_ay = res.data.d_ay;
                        this.from_date = res.data.from_date;
                        this.to_date = res.data.to_date;
                        this.communication_list = res.data.instructor_communication_list;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
        get_ay_std() {
            this.init_loader = true;
            const formData = {
                comm_type: "Notice",
                for: "instructor",
            };
            axios
                .post("/Communication/gerInitialData", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list), (this.academicyear = res.data.current_ay);
                    } else {
                        //error
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    //close loader
                    this.init_loader = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
    },
    mounted() {
        this.init_loader = true;
        this.get_ay_std();
        this.basepath = localStorage.getItem("awspath");
    },
    computed: {},
};
</script>

<style scoped>
.row_class {}

.row_class:hover {
    color: white !important;
    background: gray !important;
    background: gray;
    box-shadow: 10px 10px 10px grey !important;
    -webkit-transition: box-shadow 0.3s ease-in !important;
}

.weaklyoff {
    background: white !important;
    font-weight: bold !important;
}

.weaklyoff2 {
    background: #dbd7d7 !important;
}

.allot-btn,
.allot-icon,
.info-icon {
    transition: 0.3s;
}

.allot-btn:hover .allot-icon {
    color: white;
}

.allot-btn:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
}

.info-icon:hover {
    background-color: #193a9a !important;
    border-color: #193a9a !important;
    color: white;
    border-radius: 100%;
}

.table-sub-title {
    margin-left: 1%;
    font-weight: 500;
    color: #999;
}

.box_2 {
    background-color: #eeecec !important;
    margin: 8px !important;
    padding: 8px;
    border: 2px solid #eeecec !important;
}

.box_3 {
    background-color: white !important;
    margin: 8px !important;
    padding: 8px;
    border: 2px solid #d3d3d3 !important;
}

@media print {
    body {
        height: 100%;
        width: 100%;
    }

    .no-display {
        display: none !important;
    }

    .v-data-footer,
    .v-data-footer__select,
    .v-data-footer__pagination {
        display: none !important;
        visibility: hidden !important;
    }

    .v-data-table table,
    .v-data-table__wrapper {
        width: 100% !important;
        display: block !important;
    }

    table,
    th,
    td {
        border-collapse: collapse !important;
        border: 1px solid black !important;
        width: 100%;
        text-align: right !important;
    }
}
</style>
